// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3Q6c7","label":"Category_label__phutJ","content":"Category_content__1taho","header":"Category_header__Xr2wJ","location":"Category_location__1AWGy"};